import { IGenericReason } from 'APIPackage/CatalogsModule/interfaces/IGenericReason';

import { IGenericReasonSelectOption } from '../interfaces/IGenericReasonSelectOption';

export const createGenericReasonSelectOption = (genericReason: IGenericReason): IGenericReasonSelectOption => ({
  ...genericReason,
  label: genericReason.shortTitle,
  value: genericReason.id,
});
